/**
 * Investor Share Routes
 *
 * Route definitions for the investor-shares module.
 */

import { lazy } from 'react';

const InvestorShareManagement = lazy(() => import('./InvestorShareManagement'));
const InvestorShareCalculation = lazy(() => import('./InvestorShareCalculation'));
const InvestorShareBatchReview = lazy(() => import('./InvestorShareBatchReview'));

export const investorShareRoutes = [
    {
        path: 'investor-shares',
        element: <InvestorShareManagement />,
    },
    {
        path: 'investor-shares/batch-review/:estateId',
        element: <InvestorShareBatchReview />,
    },
    {
        path: 'investor-shares/:id',
        element: <InvestorShareCalculation />,
    },
];
